module.exports = __webpack_public_path__ + "a768e7de/img/share-action-icon.9c12578c.svg";